import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from '@paypalcorp/pp-react';
import LanguageSelector from '../languageSelectorMenu';
import {
  Help,
  Security,
  Feedback,
  ReportInappropriateContent,
  Imprint,
  CopyRight,
  Privacy,
  Policy,
  Legal,
  CombinedFinancialServicesText,
} from './footerLinks';
import templateData from '../../utility/getTemplateData';
import * as FPT from '../../utility/fpt';
import AppDispatcher from '../../dispatcher/AppDispatcher';
import AppStore from '../../stores/AppStore';
import { isNotFullScreen, isInContext } from '../../utility/inContextDonation';
import { isExternalFlow } from '../../utility/externalIntegrationUtils';

export default function Footer() {
  const [isLanguageSelectorEnabled, setIsLanguageSelectorEnabled] =
    useState(false);

  if (isExternalFlow() && isInContext() && isNotFullScreen()) {
    return null;
  }

  useEffect(() => {
    setIsLanguageSelectorEnabled(AppStore.getLanguageSelectorState());

    const dispatcherMessages = AppDispatcher.register((payload) => {
      if (payload.action?.actionType === 'SHOW_LANGUAGE_SELECTOR') {
        const { item } = payload.action;
        setIsLanguageSelectorEnabled(item);
      }
    });

    return () => {
      AppDispatcher.unregister(dispatcherMessages);
    };
  }, []);

  const handleQualtrics = () => {
    window.PAYPAL?.analytics?.reloadQualtrics(
      'donatenodeweb-consumer-qualtrics'
    );
  };

  const trackReportLink = () => {
    FPT.trackLinkClick('reportInappropriateContent');
  };

  return (
    <footer>
      <Container className="footer_container" fluid={true}>
        <Row>
          <Col xs={9} md={9} className="footer_d_one">
            <ul>
              <Help />
              <Security />
              <ReportInappropriateContent onClick={trackReportLink} />
              {templateData?.pxp?.showFeedbackExp?.experiment && (
                <Feedback handleQualtrics={handleQualtrics} />
              )}

              {/* Austria, Switzerland, Germany Imprint Link */}
              {['AT', 'CH', 'DE'].includes(templateData.country) && <Imprint />}
            </ul>
          </Col>

          {isLanguageSelectorEnabled && (
            <Col xs={3} md={3}>
              <LanguageSelector />
            </Col>
          )}
        </Row>
        <Row className="footer_d_two">
          <Col>
            <ul>
              <CopyRight />
              <Privacy />
              <Legal />
              <Policy />
            </ul>
          </Col>
        </Row>

        {/* Australia Combined Financial Services Guide and Product Disclosure Statement */}
        {templateData.country === 'AU' && <CombinedFinancialServicesText />}
      </Container>
    </footer>
  );
}
